<template>
    <div class="d-flex justify-space-between">
        <div class="d-flex">
            <p class="number my-0 pa-1 mr-2" style="height: 27px">
                {{ number }}
            </p>

            <div>
                <p class="subtitle-1 font-weight-bold primary--text my-0">
                    {{ item.title }}
                </p>
                <p class="subtitle-2 grey--text my-0 mt-n1">
                    Quantity: {{ item.quantity }} Hours
                </p>
            </div>
        </div>

        <div class="text-center" v-if="show">
            <v-btn
                color="amber darken-2"
                @click="$emit('edit')"
                class="mt-2"
                fab
                x-small
                dark
                style="height: 25px; width: 25px"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </div>

        <div class="d-flex">
            <p class="title primary--text mb-0 font-weight-bold mt-1">
                ${{ formatAmount(item.price) }}
            </p>
            <v-btn
                v-if="show"
                icon
                color="red"
                class="ml-2 mt-2"
                style="width: 10px; height: 23px;"
                @click="$emit('delete', item.index)"
            >
                <v-icon small>mdi-minus-circle</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: Object,
        show: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        number() {
            const { index } = this.item;
            if(index > 9) return index;
            return `0${index}`;
        },
    },
}
</script>

<style scoped>
.number {
    background-color: rgba(196, 196, 196, 0.4);
}
</style>